import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const assetConfig = {
  cash: [
    { name: 'description', label: 'Description', type: 'text', optional: true },
    { name: 'amount', label: 'Amount', type: 'number' },
    { name: 'exemption_code', label: 'Exemption Code', type: 'text', optional: true },
    { name: 'exemption_amount', label: 'Exemption Amount', type: 'number', optional: true },
  ],
  deposit: [
    { name: 'account_type', label: 'Account Type', type: 'select', options: ['checking','savings','cd','other'] },
    { name: 'institution_name', label: 'Institution Name', type: 'text' },
    { name: 'amount', label: 'Amount', type: 'number' },
    { name: 'exemption_code', label: 'Exemption Code', type: 'text', optional: true },
    { name: 'exemption_amount', label: 'Exemption Amount', type: 'number', optional: true },
  ],
  brokerageAccount: [
    { name: 'institution_name', label: 'Institution Name', type: 'text' },
    { name: 'amount', label: 'Amount', type: 'number' },
    { name: 'exemption_code', label: 'Exemption Code', type: 'text', optional: true },
    { name: 'exemption_amount', label: 'Exemption Amount', type: 'number', optional: true },
  ],
  nonPublicTradedStock: [
    { name: 'entity_name', label: 'Entity Name', type: 'text' },
    { name: 'ownership_percentage', label: 'Ownership %', type: 'number' },
    { name: 'amount', label: 'Amount', type: 'number' },
    { name: 'exemption_code', label: 'Exemption Code', type: 'text', optional: true },
    { name: 'exemption_amount', label: 'Exemption Amount', type: 'number', optional: true },
  ],
  bond: [
    { name: 'issuer', label: 'Issuer', type: 'text' },
    { name: 'amount', label: 'Amount', type: 'number' },
    { name: 'exemption_code', label: 'Exemption Code', type: 'text', optional: true },
    { name: 'exemption_amount', label: 'Exemption Amount', type: 'number', optional: true },
  ],
  retirementAccount: [
    { name: 'entity', label: 'Entity', type: 'text' },
    { name: 'account_type', label: 'Account Type', type:'select', options: ['401k','retirement','IRA', 'keogh','other'] },
    { name: 'amount', label: 'Amount', type: 'number' },
    { name: 'exemption_code', label: 'Exemption Code', type: 'text', optional: true },
    { name: 'exemption_amount', label: 'Exemption Amount', type: 'number', optional: true },
  ],
  securityDeposit: [
    { name: 'institution', label: 'Institution', type: 'text' },
    { name: 'deposit_type', label: 'Deposit Type', type:'select', options: ['electric','gas','heating oil', 'security deposit', 'prepaid rent','telephone','water','rented furniture','other'] },
    { name: 'amount', label: 'Amount', type: 'number' },
    { name: 'exemption_code', label: 'Exemption Code', type: 'text', optional: true },
    { name: 'exemption_amount', label: 'Exemption Amount', type: 'number', optional: true },
  ],
  annuity: [
    { name: 'issuer', label: 'Issuer', type: 'text' },
    { name: 'amount', label: 'Amount', type: 'number' },
    { name: 'exemption_code', label: 'Exemption Code', type: 'text', optional: true },
    { name: 'exemption_amount', label: 'Exemption Amount', type: 'number', optional: true },
  ],
  educationIra: [
    { name: 'issuer', label: 'Issuer', type: 'text' },
    { name: 'amount', label: 'Amount', type: 'number' },
    { name: 'exemption_code', label: 'Exemption Code', type: 'text', optional: true },
    { name: 'exemption_amount', label: 'Exemption Amount', type: 'number', optional: true },
  ],
  trust: [
    { name: 'description', label: 'Description', type: 'textarea' },
    { name: 'amount', label: 'Amount', type: 'number' },
    { name: 'exemption_code', label: 'Exemption Code', type: 'text', optional: true },
    { name: 'exemption_amount', label: 'Exemption Amount', type: 'number', optional: true },
  ],
  patent: [
    { name: 'issuer', label: 'Issuer', type: 'text' },
    { name: 'amount', label: 'Amount', type: 'number' },
    { name: 'exemption_code', label: 'Exemption Code', type: 'text', optional: true },
    { name: 'exemption_amount', label: 'Exemption Amount', type: 'number', optional: true },
  ],
  franchise: [
    { name: 'issuer', label: 'Franchisor', type: 'text' },
    { name: 'amount', label: 'Amount', type: 'number' },
    { name: 'exemption_code', label: 'Exemption Code', type: 'text', optional: true },
    { name: 'exemption_amount', label: 'Exemption Amount', type: 'number', optional: true },
  ],
  taxRefund: [
    { name: 'tax_type', label: 'Tax Type', type: 'select', options: ['federal','state','local'] },
    { name: 'description', label: 'Description', type: 'textarea' },
    { name: 'amount', label: 'Amount', type: 'number' },
    { name: 'exemption_code', label: 'Exemption Code', type: 'text', optional: true },
    { name: 'exemption_amount', label: 'Exemption Amount', type: 'number', optional: true },
  ],
  obligation: [
    { name: 'obligation_type', label: 'Obligation Type', type: 'select', options: ['alimony','maintenance','support','divorce_settlement','property_settlement'] },
    { name: 'description', label: 'Description', type: 'textarea' },
    { name: 'amount', label: 'Amount', type: 'number' },
    { name: 'exemption_code', label: 'Exemption Code', type: 'text', optional: true },
    { name: 'exemption_amount', label: 'Exemption Amount', type: 'number', optional: true },
  ],
  otherAmountOwed: [
    { name: 'description', label: 'Description', type: 'textarea' },
    { name: 'amount', label: 'Amount', type: 'number' },
    { name: 'exemption_code', label: 'Exemption Code', type: 'text', optional: true },
    { name: 'exemption_amount', label: 'Exemption Amount', type: 'number', optional: true },
  ],
  insuranceInterest: [
    { name: 'company', label: 'Company', type: 'text' },
    { name: 'beneficiary', label: 'Beneficiary', type: 'text' },
    { name: 'amount', label: 'Amount', type: 'number' },
    { name: 'exemption_code', label: 'Exemption Code', type: 'text', optional: true },
    { name: 'exemption_amount', label: 'Exemption Amount', type: 'number', optional: true },
  ],
  inheritanceInterest: [
    { name: 'description', label: 'Description', type: 'textarea' },
    { name: 'amount', label: 'Amount', type: 'number' },
    { name: 'exemption_code', label: 'Exemption Code', type: 'text', optional: true },
    { name: 'exemption_amount', label: 'Exemption Amount', type: 'number', optional: true },
  ],
  lawsuitInterest: [
    { name: 'description', label: 'Description', type: 'textarea' },
    { name: 'amount', label: 'Amount', type: 'number' },
    { name: 'exemption_code', label: 'Exemption Code', type: 'text', optional: true },
    { name: 'exemption_amount', label: 'Exemption Amount', type: 'number', optional: true },
  ],
  contingentClaim: [
    { name: 'description', label: 'Description', type: 'textarea' },
    { name: 'amount', label: 'Amount', type: 'number' },
    { name: 'exemption_code', label: 'Exemption Code', type: 'text', optional: true },
    { name: 'exemption_amount', label: 'Exemption Amount', type: 'number', optional: true },
  ],
  otherFinancialAsset: [
    { name: 'description', label: 'Description', type: 'textarea' },
    { name: 'amount', label: 'Amount', type: 'number' },
    { name: 'exemption_code', label: 'Exemption Code', type: 'text', optional: true },
    { name: 'exemption_amount', label: 'Exemption Amount', type: 'number', optional: true },
  ],
};

const endpointMap = {
  cash: 'cash-assets',
  deposit: 'deposits',
  brokerageAccount: 'brokerage-accounts',
  nonPublicTradedStock: 'nonpublic-stocks',
  bond: 'bonds',
  retirementAccount: 'retirement-accounts',
  securityDeposit: 'security-deposits',
  annuity: 'annuities',
  educationIra: 'education-iras',
  trust: 'trusts',
  patent: 'patents',
  franchise: 'franchises',
  taxRefund: 'tax-refunds',
  obligation: 'obligations',
  otherAmountOwed: 'other-amounts-owed',
  insuranceInterest: 'insurance-interests',
  inheritanceInterest: 'inheritance-interests',
  lawsuitInterest: 'lawsuit-interests',
  contingentClaim: 'contingent-claims',
  otherFinancialAsset: 'other-financial-assets',
};

export default function FinancialAssetsModal({ isOpen, onClose, type, item, onSave, caseId, exemptions = [], scope = '' }) {
  // Convert camelCase 'type' into Title Case for display
  const displayType = type
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, str => str.toUpperCase());
  const config = assetConfig[type] || [];
  const [formState, setFormState] = useState({});

  // Include default exemption_code in options if it's not in the fetched exemptions
  const exemptionOptions = [...exemptions];
  const currentCode = formState.exemption_code;
  if (currentCode && !exemptions.some(ex => ex.law === currentCode)) {
    exemptionOptions.unshift({ law: currentCode, asset_name: currentCode });
  }

  useEffect(() => {
    const initial = {};
    config.forEach(f => {
      initial[f.name] = item && item[f.name] != null ? item[f.name] : '';
    });
    // Default exemption_code for TN if adding new item
    if (!item && (scope === 'TN' || exemptions.some(ex => ex.state === 'TN'))) {
      if (type === 'retirementAccount') {
        initial.exemption_code = '26-2-111 (1)(D)';
      } else {
        initial.exemption_code = '26-2-103';
      }
    }
    setFormState(initial);
  }, [type, item, exemptions, scope]);

  const handleChange = (name, val) => setFormState(prev => ({ ...prev, [name]: val }));

  const handleSubmit = async e => {
    e.preventDefault();
    const url = item
      ? `${process.env.REACT_APP_API_URL}/case/${caseId}/${endpointMap[type]}/${item.id}/edit/`
      : `${process.env.REACT_APP_API_URL}/case/${caseId}/${endpointMap[type]}/add/`;
    const method = item ? 'PUT' : 'POST';
    const res = await fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
      },
      body: JSON.stringify(formState),
    });
    if (!res.ok) {
      alert('Save failed');
      return;
    }
    const saved = await res.json();
    onSave(saved);
    onClose();
  };

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6">
        <h3 className="text-lg font-semibold mb-4">
          {item ? `Edit ${displayType}` : `Add ${displayType}`}
        </h3>
        <form onSubmit={handleSubmit} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {/* Render non-amount fields first */}
          {config
            .filter(f => f.name !== 'amount' && f.name !== 'exemption_amount')
            .map(field => (
              <div key={field.name} className="col-span-2">
                {/* existing label-and-input logic */}
                <label className="block text-sm font-medium text-gray-700">
                  {field.label}
                </label>
                {/* reuse your existing conditional rendering for textarea/select/input here */}
                {field.name === 'exemption_code' ? (
                  <select
                    value={formState[field.name]}
                    onChange={e => handleChange(field.name, e.target.value)}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  >
                    <option value="">None</option>
                    {exemptionOptions.map(ex => (
                      <option key={ex.law} value={ex.law}>
                        {ex.asset_name} — {ex.law}
                      </option>
                    ))}
                  </select>
                ) : field.type === 'textarea' ? (
                  <textarea
                    rows={3}
                    value={formState[field.name]}
                    onChange={e => handleChange(field.name, e.target.value)}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    {...(!field.optional && { required: true })}
                  />
                ) : field.type === 'select' ? (
                  <select
                    value={formState[field.name]}
                    onChange={e => handleChange(field.name, e.target.value)}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    {...(!field.optional && { required: true })}
                  >
                    <option value="">Select…</option>
                    {field.options.map(opt => (
                      <option key={opt} value={opt}>
                        {opt.charAt(0).toUpperCase() + opt.slice(1).replace('_', ' ')}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    type={field.type}
                    step={field.type === 'number' ? '0.01' : undefined}
                    value={formState[field.name]}
                    onChange={e =>
                      handleChange(
                        field.name,
                        field.type === 'number' ? parseFloat(e.target.value) : e.target.value
                      )
                    }
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    {...(!field.optional && { required: true })}
                  />
                )}
              </div>
            ))}

          {/* Group amount and exemption_amount */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 col-span-2">
            {/* Amount */}
            <div>
              <label className="block text-sm font-medium text-gray-700">Amount</label>
              <input
                type="number"
                step="0.01"
                value={formState.amount}
                onChange={e => handleChange('amount', parseFloat(e.target.value))}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                required
              />
            </div>
            {/* Exemption Amount */}
            <div>
              <label className="block text-sm font-medium text-gray-700">Exemption Amount</label>
              <input
                type="number"
                step="0.01"
                value={formState.exemption_amount}
                onChange={e => handleChange('exemption_amount', parseFloat(e.target.value))}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>
          </div>
          <div className="flex justify-end space-x-2 pt-4 col-span-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

FinancialAssetsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  item: PropTypes.object,
  onSave: PropTypes.func.isRequired,
  caseId: PropTypes.string.isRequired,
  exemptions: PropTypes.array.isRequired,
};